jQuery(document).ready(function($) {
            
    $(".pdm-section.featured-posts .the-posts").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      centerMode: true,
      centerPadding: 0
    });

    $(".pdm-section.videos-slider .videos-slider__slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: true,
      centerMode: true,
      centerPadding: 0
    });

    var urlParams = (function (strParam) {
      var objParams = {};
  
      function init() {
        objParams = {};
        var arrURLParams = window.location.search.replace('?', '').split('&');
        arrURLParams.map(function (val) {
          var arrPair = val.split('=');
          objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
        });
      }
      init();
      return {
        get: function (strParam) {
          return objParams[strParam];
        },
        pull: init
      }
    }());


    var PDMLightbox = (function () {
      //Lightbox reset - This lightbox is empty and present on all pages
      var $lightbox = $('.pdm-lightbox--reset');

      //it's content can be filled from various sources
      //after close, the content is wiped
      var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');

      $('body').on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target],.lightbox-trigger', function (e) {

          e.preventDefault();
          console.log("open modal");
          var iframe = $(this).data('lightbox-iframe');

          if (iframe) {
              var youtubePattern = /(?:http?s?:\/\/)?(?:www\.)?youtu(be\.com\/|\.be\/)(embed\/(.+)(\?.+)?|watch\?v=(.+)(\&.+)?)/g;
              var vimeoPattern = /(?:http?s?:\/\/)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/g;

              if (youtubePattern.test(iframe)) {
                  classes += ' youtube-vid'

                  replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//www.youtube.com/embed/$3?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';

                  iframe = iframe.replace(youtubePattern, replacement);

              }

              if (vimeoPattern.test(iframe)) {

                  classes += ' vimeo-vid'

                  replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//player.vimeo.com/video/$3?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';

                  iframe = iframe.replace(vimeoPattern, replacement);

              }

              $lightbox_content.html('<div class="video-embed">' + iframe + '</div>');
          } else {
              if ($(this).data('lightbox-content')) {
                  var content = $(this).data('lightbox-content');
              } else if ($(this).data('lightbox-target')) {
                  var target = $(this).data('lightbox-target');
                  var content = $('#' + target).html();
              } else {
                  var content = $(this).next('.lightbox-content').html();
              }
              $lightbox_content.html(content);
          }

          var classes = $(this).data('lightbox-classes');
          $lightbox.addClass('active').addClass(classes);

      });

      function closeModal($lightbox) {
          $lightbox.removeClass('active');
          $('body').removeClass('noScroll');
          //wait before removing classes till lightbox closses
          if ($lightbox.hasClass('pdm-lightbox--reset')) {
              setTimeout(function () {
                  // $lightbox.find('.pdm-lightbox__content').empty();
                  // $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
              }, 750);
          }
      }

      function openModal($lightbox) {
          $lightbox.addClass('active');
          $('body').addClass('noScroll');
      }

      function updateModal($lightbox, $content) {
          $lightbox.find('.pdm-lightbox__content').html($content);
      }

      $('.pdm-lightbox').on('click', function (e) {
          if (e.target == this) {
              closeModal($(this));
          }
      });

      $('.pdm-lightbox__close').click(function (e) {
          e.stopPropagation();
          closeModal($(this).closest('.pdm-lightbox'));
      });
      return {
          close: closeModal,
          open: openModal,
          update: updateModal
      };
  }());


    var Header = (function(){
      $dropdropLink = $('.pdm-blog-nav li.haslinks > a');
      $dropdropLink.click(function(e){
        e.preventDefault();
        $(this).closest('.pdm-blog-nav').toggleClass('active');
      });
    }());


    var TOC = (function(){
      $headings = $('.article-template__content h2');

      if ($headings.length) {

          $('.article').addClass('article--toc');
          
          $('.toc').show();

          $('.toc').addClass("active");

          $headings.each(function () {
             
              var text = $(this).text().replace(':', '');
              //                console.log(text);

              if(text == "") return;

              var id = text.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-').toLowerCase();
              $(this).attr('id', id);

              $('.toc ul').append('<li><button class="reset" data-target="' + id + '">' + text + '</button>');
          });

          $('.toc').on('click', 'button', function () {
              //                $('.toc li.active').removeClass('active');
              //                $(this).parent().addClass('active');
              var target = $(this).data('target');
              $('html, body').animate({
                  scrollTop: $('#' + target).offset().top - 100
              }, 1000);
          });

      }
    }());



    var LoadMore = (function(){
  	
        var loadmoreBtn = $(".pdm-main-blog .loadmore");
        
        var nextUrl;
        var postListWrapper;
        var loadSpinner = $('.loadmore-spinner');
        loadmoreBtn.click(function(){
          
          postListWrapper = $(this).closest('.pdm-main-blog').find(".pdm-blog-grid");
          nextURL = postListWrapper.data('next-url');
          console.log("next url is " + nextURL);
          $.ajax({
            url: nextURL,
            type: "GET",
            dataType: 'html',
            beforeSend: function(){
            
              loadmoreBtn.hide();
              loadSpinner.show();
            
            },
          }).done(function(data){
    
              loadSpinner.hide();
              var postList = $(data).find('.pdm-blog-grid');
          
              postListWrapper.append(postList.html());
              var nextLink = postList.data('next-url');
                
              if(nextLink){
                loadmoreBtn.show();
              }
              postListWrapper.data('next-url', nextLink);
              
           
          });
        });
    }());

    var LoadMoreSortedPosts = (function () {
        var $section = $('.pdm-main-blog__sorted');
        if (!$section.length) { return; }

        var $posts = $section.find('.blog-articles__article');
        var $loadBtn = $section.find('.load-more__btn');
        var postsToLoad = 6;

        $posts.hide();
        $posts.slice(0, postsToLoad).show();

        $loadBtn.click(function () {
            var shown = $('.blog-articles__article:visible').length;
            var blogVisible = $section.find('.blog-articles__article:visible').length;
            console.log('shown ' + shown + " visible " + blogVisible);
            $posts.slice(shown - 1, shown + postsToLoad).show();

            if ($posts.length == blogVisible ) {
              $loadBtn.hide();
            }
        });

    }());

    var iframeShow = (function() {

      var $body = $('body');
      $body.on('click', '.iframe-show', function(e) {
        var _this = $(this);
          $(this).parents(".video-section").find('.iframe-content').addClass("active");
          $(this).parents(".video-section").find('.lighbox-content').hide();
          setTimeout(function() {
             // _this.parents("section").find("iframe")[0].src += "?&autoplay=1&VQ=HD720";
          }, 500);
      });

  }());

  var Accordions = (function () {
   
    var $accordions = $('.accordion');
    if (!$accordions.length) { return; }

    $accordions.each(function () {
        $this = $(this).find('.accordion__trigger');
        if ($this.hasClass('active')) {
            $this.next().slideToggle(250);
        }
    });
    $(document).on('click', '.accordion__trigger', function () {
        var $this = $(this);
        $this.toggleClass('active');
        $this.next().slideToggle(250);
        $this.parent().siblings().find('.accordion__trigger').removeClass('active').next().slideUp(250);
    });
}());

var postSort = (function () {
 
  if (!$('#sortby').length) {
    return false;
  }
  console.log("post sort after");
  var currentFilter = urlParams.get('sort_by');

  if (currentFilter != '') {
    $('#sortby option[value="' + currentFilter + '"]').attr('selected', 'selected');
  }

  $('#sortby').change(function () {
    console.log("sort change");
    var val = $(this).val();
    location.search = 'view=' + val;
  });

}());

var featuredProductsSlider = (function(){
  var $sliders = $(".featured-products.pdm-section .featured-products__slider");

    if (!$sliders.length) {
      return;
    }
    console.log("product slider");
    $sliders.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      centerMode: true,
      centerPadding: 0,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 3,            
          }
        }
      ]
    });
}());




	
	var filters = (function(){
		
		var $filterBar = $('.blog-filters');
		
		if( !$filterBar.length ){ return }

    var openBtn = $('#open-filter-btn');
    var closeBtn = $('#close-filter-btn');
    openBtn.click(function(){
      $filterBar.addClass("active");
    });

    closeBtn.click(function(){
      $filterBar.removeClass("active");
    });
		
		var $filters = $filterBar.find('input');
		
		var baseURL = $filterBar.data('url');
		var tags = '';
		
		var $submit = $filterBar.find('.blog-filter-submit');
		
		function updateTagURL(){
			
			tags = '';
			
			$filters.each(function(){
				var $this = $(this);
				if( $this.hasClass('active') ){
					tags += $this.val() + '+';
				}
			});
			
			tags = tags.substring(0,tags.length - 1);
			
		}
		
		$filters.click(function(){
			
			var $this = $(this);
			var $catFilters = $this.closest('.accordion').find('input');
			
			if( $this.hasClass('active') ){
				$this.removeClass('active');
				$this.prop('checked',false);
			}else{
				$catFilters.removeClass('active');
				$this.addClass('active');
			}
			
			updateTagURL();
			
		});
		
		$submit.click(function(){
			
			if( tags != '' ){
				window.location = baseURL + /tagged/ + tags;
			}else{
				window.location = baseURL;
			}
			
		});
		
	}());
    

});

